/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * ChiRhos API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import * as querystring from "querystring";
import * as url from "url";
import * as portableFetch from "portable-fetch";
const BASE_PATH = "https://localhost".replace(/\/+$/, "");
/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    constructor(configuration, basePath = BASE_PATH, fetch = portableFetch) {
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}
;
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(field, msg) {
        super(msg);
        this.field = field;
    }
}
/**
 * @export
 * @namespace Sort
 */
export var Sort;
(function (Sort) {
    /**
     * @export
     * @enum {string}
     */
    let DirectionResolvedEnum;
    (function (DirectionResolvedEnum) {
        DirectionResolvedEnum[DirectionResolvedEnum["NUMBER_0"] = 0] = "NUMBER_0";
        DirectionResolvedEnum[DirectionResolvedEnum["NUMBER_1"] = 1] = "NUMBER_1";
    })(DirectionResolvedEnum = Sort.DirectionResolvedEnum || (Sort.DirectionResolvedEnum = {}));
})(Sort || (Sort = {}));
/**
 * EventApi - fetch parameter creator
 * @export
 */
export const EventApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Event`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options = {}) {
            const localVarPath = `/api/Event/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (importIdentifier !== undefined) {
                localVarQueryParameter['importIdentifier'] = importIdentifier;
            }
            if (createDependencies !== undefined) {
                localVarQueryParameter['createDependencies'] = createDependencies;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options = {}) {
            const localVarPath = `/api/Event/Favourite/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentDeleteReport(entityId, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReport(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReportForGroupType(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentRunReport(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReport(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReportForGroupType(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Absent/SaveForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendDeleteReport(entityId, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Person unique code is ignored for this call, as it is not suppored from kiosk mode
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendGetForEventAndPerson(request, options = {}) {
            const localVarPath = `/api/Event/Attend/GetForEventAndPerson`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReport(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReportForGroupType(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendMaybe(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Maybe`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendNo(request, options = {}) {
            const localVarPath = `/api/Event/Attend/No`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Filters collection will filter the Events
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendRunReport(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReport(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReportForGroupType(value, options = {}) {
            const localVarPath = `/api/Event/Attend/Report/SaveForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendYes(request, options = {}) {
            const localVarPath = `/api/Event/Attend/Yes`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIn(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckIn`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByAttendanceCode(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckInByAttendanceCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventByCodeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByPersonCode(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckInByPersonCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventByPersonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInMultiple(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckInMultiple`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceMultipleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOut(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckOut`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByAttendanceCode(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckOutByAttendanceCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventByCodeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByPersonCode(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckOutByPersonCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventByPersonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutMultiple(request, options = {}) {
            const localVarPath = `/api/Event/Attend/CheckOutMultiple`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceMultipleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options = {}) {
            const localVarPath = `/api/Event/Resource/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventDeleteReport(entityId, options = {}) {
            const localVarPath = `/api/Event/Report/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReport(request, options = {}) {
            const localVarPath = `/api/Event/Report/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReportForGroupType(request, options = {}) {
            const localVarPath = `/api/Event/Report/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRunReport(value, options = {}) {
            const localVarPath = `/api/Event/Report/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReport(value, options = {}) {
            const localVarPath = `/api/Event/Report/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReportForGroupType(value, options = {}) {
            const localVarPath = `/api/Event/Report/SaveForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Event/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode(request, options = {}) {
            const localVarPath = `/api/Event/GetByCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventByCodeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedback(request, options = {}) {
            const localVarPath = `/api/Event/Feedback/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options = {}) {
            const localVarPath = `/api/Event/Note/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options = {}) {
            const localVarPath = `/api/Event/Resource/File`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttendanceForEvent(request, options = {}) {
            const localVarPath = `/api/Event/Attend/ListForEvent`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEventRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options = {}) {
            const localVarPath = `/api/Event/ListForGroup`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists possible attendees that are invited. Note that for open events this will return null/empty
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvited(request, options = {}) {
            const localVarPath = `/api/Event/Attend/ListInvited`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lists all events that the current person can manage (write access). Note that this is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequestTo} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManaged(request, options = {}) {
            const localVarPath = `/api/Event/ListManaged`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequestTo" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options = {}) {
            const localVarPath = `/api/Event/Note/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} entityId
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpen(entityId, from, to, options = {}) {
            // verify required parameter 'entityId' is not null or undefined
            if (entityId === null || entityId === undefined) {
                throw new RequiredError('entityId', 'Required parameter entityId was null or undefined when calling listOpen.');
            }
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from', 'Required parameter from was null or undefined when calling listOpen.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to', 'Required parameter to was null or undefined when calling listOpen.');
            }
            const localVarPath = `/api/Event/ListOpen/{EntityId}/{From}/{To}`
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)));
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenForHighlighted(from, to, options = {}) {
            // verify required parameter 'from' is not null or undefined
            if (from === null || from === undefined) {
                throw new RequiredError('from', 'Required parameter from was null or undefined when calling listOpenForHighlighted.');
            }
            // verify required parameter 'to' is not null or undefined
            if (to === null || to === undefined) {
                throw new RequiredError('to', 'Required parameter to was null or undefined when calling listOpenForHighlighted.');
            }
            const localVarPath = `/api/Event/ListOpenForHighlighted/{From}/{To}`
                .replace(`{${"from"}}`, encodeURIComponent(String(from)))
                .replace(`{${"to"}}`, encodeURIComponent(String(to)));
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
         * @param {ApiPossibleAttendeeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPossibleAttendees(request, options = {}) {
            const localVarPath = `/api/Event/Attend/ListPossible`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPossibleAttendeeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * All events that you (or those you own) are attending but not yet checked in to
         * @param {ApiRawPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistered(request, options = {}) {
            const localVarPath = `/api/Event/Attend/ListRegistered`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRawPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options = {}) {
            const localVarPath = `/api/Event/Resource/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Before an occurrence of an event series can be used, it must be 'materialized' to turn it into a full event
         * @param {ApiEventMaterializeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        materialize(request, options = {}) {
            const localVarPath = `/api/Event/Materialize`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventMaterializeRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options = {}) {
            const localVarPath = `/api/Event/Position`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventPositionConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAccept(request, options = {}) {
            const localVarPath = `/api/Event/Position/Accept`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
         * @param {EventPositionAssignConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssign(value, options = {}) {
            const localVarPath = `/api/Event/Position/Assign`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventPositionAssignConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssigned(request, options = {}) {
            const localVarPath = `/api/Event/Position/Assigned`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options = {}) {
            const localVarPath = `/api/Event/Position/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options = {}) {
            const localVarPath = `/api/Event/Position/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUnassign(request, options = {}) {
            const localVarPath = `/api/Event/Position/Unassign`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lists all event positions for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUpcoming(request, options = {}) {
            const localVarPath = `/api/Event/Position/Upcoming`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
         * @param {EventConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Event`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options = {}) {
            const localVarPath = `/api/Event/Note`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddNoteRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options = {}) {
            const localVarPath = `/api/Event/Resource/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (resourceJson !== undefined) {
                localVarQueryParameter['resourceJson'] = resourceJson;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This runs a multiple attend yes
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMultiple(request, options = {}) {
            const localVarPath = `/api/Event/Attend/YesMultiple`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventAttendanceMultipleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Event/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeedback(request, options = {}) {
            const localVarPath = `/api/Event/Feedback`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddReplyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Lists all events for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiEventsUpcomingRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upcoming(request, options = {}) {
            const localVarPath = `/api/Event/Upcoming`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEventsUpcomingRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventApi - functional programming interface
 * @export
 */
export const EventApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).addFavourite(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentDeleteReport(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentDeleteReport(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReport(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentListReport(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReportForGroupType(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentListReportForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentRunReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentRunReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentSaveReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReportForGroupType(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendAbsentSaveReportForGroupType(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendDeleteReport(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendDeleteReport(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Person unique code is ignored for this call, as it is not suppored from kiosk mode
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendGetForEventAndPerson(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendGetForEventAndPerson(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReport(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendListReport(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReportForGroupType(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendListReportForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendMaybe(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendMaybe(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendNo(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendNo(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The Filters collection will filter the Events
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendRunReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendRunReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendSaveReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReportForGroupType(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendSaveReportForGroupType(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendYes(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).attendYes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIn(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkIn(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByAttendanceCode(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkInByAttendanceCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByPersonCode(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkInByPersonCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInMultiple(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkInMultiple(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOut(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkOut(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByAttendanceCode(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkOutByAttendanceCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByPersonCode(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkOutByPersonCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutMultiple(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).checkOutMultiple(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).deleteResource(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventDeleteReport(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventDeleteReport(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReport(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventListReport(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReportForGroupType(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventListReportForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRunReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventRunReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReport(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventSaveReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReportForGroupType(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).eventSaveReportForGroupType(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).getByCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedback(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).getFeedback(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).getNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).getResourceFile(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttendanceForEvent(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listAttendanceForEvent(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEventRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listForGroup(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Lists possible attendees that are invited. Note that for open events this will return null/empty
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvited(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listInvited(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Lists all events that the current person can manage (write access). Note that this is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequestTo} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManaged(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listManaged(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listNotes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} entityId
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpen(entityId, from, to, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listOpen(entityId, from, to, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenForHighlighted(from, to, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listOpenForHighlighted(from, to, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
         * @param {ApiPossibleAttendeeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPossibleAttendees(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listPossibleAttendees(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * All events that you (or those you own) are attending but not yet checked in to
         * @param {ApiRawPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistered(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listRegistered(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).listResources(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Before an occurrence of an event series can be used, it must be 'materialized' to turn it into a full event
         * @param {ApiEventMaterializeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        materialize(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).materialize(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).position(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAccept(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionAccept(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
         * @param {EventPositionAssignConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssign(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionAssign(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssigned(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionAssigned(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionDelete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionList(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUnassign(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionUnassign(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Lists all event positions for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUpcoming(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).positionUpcoming(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
         * @param {EventConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).postNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This runs a multiple attend yes
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMultiple(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).registerMultiple(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeedback(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).saveFeedback(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary Lists all events for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiEventsUpcomingRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upcoming(request, options) {
            const localVarFetchArgs = EventApiFetchParamCreator(configuration).upcoming(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EventApi - factory interface
 * @export
 */
export const EventApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return EventApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            return EventApiFp(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            return EventApiFp(configuration).addFavourite(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentDeleteReport(entityId, options) {
            return EventApiFp(configuration).attendAbsentDeleteReport(entityId, options)(fetch, basePath);
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReport(request, options) {
            return EventApiFp(configuration).attendAbsentListReport(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentListReportForGroupType(request, options) {
            return EventApiFp(configuration).attendAbsentListReportForGroupType(request, options)(fetch, basePath);
        },
        /**
         * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentRunReport(value, options) {
            return EventApiFp(configuration).attendAbsentRunReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReport(value, options) {
            return EventApiFp(configuration).attendAbsentSaveReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendAbsentSaveReportForGroupType(value, options) {
            return EventApiFp(configuration).attendAbsentSaveReportForGroupType(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendDeleteReport(entityId, options) {
            return EventApiFp(configuration).attendDeleteReport(entityId, options)(fetch, basePath);
        },
        /**
         * Person unique code is ignored for this call, as it is not suppored from kiosk mode
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendGetForEventAndPerson(request, options) {
            return EventApiFp(configuration).attendGetForEventAndPerson(request, options)(fetch, basePath);
        },
        /**
         * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReport(request, options) {
            return EventApiFp(configuration).attendListReport(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendListReportForGroupType(request, options) {
            return EventApiFp(configuration).attendListReportForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendMaybe(request, options) {
            return EventApiFp(configuration).attendMaybe(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendNo(request, options) {
            return EventApiFp(configuration).attendNo(request, options)(fetch, basePath);
        },
        /**
         * The Filters collection will filter the Events
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendRunReport(value, options) {
            return EventApiFp(configuration).attendRunReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReport(value, options) {
            return EventApiFp(configuration).attendSaveReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendSaveReportForGroupType(value, options) {
            return EventApiFp(configuration).attendSaveReportForGroupType(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        attendYes(request, options) {
            return EventApiFp(configuration).attendYes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkIn(request, options) {
            return EventApiFp(configuration).checkIn(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByAttendanceCode(request, options) {
            return EventApiFp(configuration).checkInByAttendanceCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInByPersonCode(request, options) {
            return EventApiFp(configuration).checkInByPersonCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInMultiple(request, options) {
            return EventApiFp(configuration).checkInMultiple(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOut(request, options) {
            return EventApiFp(configuration).checkOut(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByAttendanceCode(request, options) {
            return EventApiFp(configuration).checkOutByAttendanceCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventByPersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutByPersonCode(request, options) {
            return EventApiFp(configuration).checkOutByPersonCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkOutMultiple(request, options) {
            return EventApiFp(configuration).checkOutMultiple(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            return EventApiFp(configuration).deleteResource(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventDeleteReport(entityId, options) {
            return EventApiFp(configuration).eventDeleteReport(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReport(request, options) {
            return EventApiFp(configuration).eventListReport(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventListReportForGroupType(request, options) {
            return EventApiFp(configuration).eventListReportForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventRunReport(value, options) {
            return EventApiFp(configuration).eventRunReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReport(value, options) {
            return EventApiFp(configuration).eventSaveReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        eventSaveReportForGroupType(value, options) {
            return EventApiFp(configuration).eventSaveReportForGroupType(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return EventApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventByCodeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByCode(request, options) {
            return EventApiFp(configuration).getByCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedback(request, options) {
            return EventApiFp(configuration).getFeedback(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options) {
            return EventApiFp(configuration).getNote(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            return EventApiFp(configuration).getResourceFile(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAttendanceForEvent(request, options) {
            return EventApiFp(configuration).listAttendanceForEvent(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEventRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options) {
            return EventApiFp(configuration).listForGroup(request, options)(fetch, basePath);
        },
        /**
         * Lists possible attendees that are invited. Note that for open events this will return null/empty
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvited(request, options) {
            return EventApiFp(configuration).listInvited(request, options)(fetch, basePath);
        },
        /**
         *
         * @summary Lists all events that the current person can manage (write access). Note that this is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequestTo} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listManaged(request, options) {
            return EventApiFp(configuration).listManaged(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            return EventApiFp(configuration).listNotes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} entityId
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpen(entityId, from, to, options) {
            return EventApiFp(configuration).listOpen(entityId, from, to, options)(fetch, basePath);
        },
        /**
         *
         * @param {Date} from
         * @param {Date} to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenForHighlighted(from, to, options) {
            return EventApiFp(configuration).listOpenForHighlighted(from, to, options)(fetch, basePath);
        },
        /**
         * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
         * @param {ApiPossibleAttendeeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPossibleAttendees(request, options) {
            return EventApiFp(configuration).listPossibleAttendees(request, options)(fetch, basePath);
        },
        /**
         * All events that you (or those you own) are attending but not yet checked in to
         * @param {ApiRawPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegistered(request, options) {
            return EventApiFp(configuration).listRegistered(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            return EventApiFp(configuration).listResources(request, options)(fetch, basePath);
        },
        /**
         * Before an occurrence of an event series can be used, it must be 'materialized' to turn it into a full event
         * @param {ApiEventMaterializeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        materialize(request, options) {
            return EventApiFp(configuration).materialize(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options) {
            return EventApiFp(configuration).position(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAccept(request, options) {
            return EventApiFp(configuration).positionAccept(request, options)(fetch, basePath);
        },
        /**
         * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
         * @param {EventPositionAssignConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssign(value, options) {
            return EventApiFp(configuration).positionAssign(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionAssigned(request, options) {
            return EventApiFp(configuration).positionAssigned(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options) {
            return EventApiFp(configuration).positionDelete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options) {
            return EventApiFp(configuration).positionList(request, options)(fetch, basePath);
        },
        /**
         * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUnassign(request, options) {
            return EventApiFp(configuration).positionUnassign(request, options)(fetch, basePath);
        },
        /**
         *
         * @summary Lists all event positions for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionUpcoming(request, options) {
            return EventApiFp(configuration).positionUpcoming(request, options)(fetch, basePath);
        },
        /**
         * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
         * @param {EventConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return EventApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options) {
            return EventApiFp(configuration).postNote(request, options)(fetch, basePath);
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            return EventApiFp(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(fetch, basePath);
        },
        /**
         * This runs a multiple attend yes
         * @param {ApiEventAttendanceMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerMultiple(request, options) {
            return EventApiFp(configuration).registerMultiple(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return EventApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveFeedback(request, options) {
            return EventApiFp(configuration).saveFeedback(request, options)(fetch, basePath);
        },
        /**
         *
         * @summary Lists all events for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
         * @param {ApiEventsUpcomingRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upcoming(request, options) {
            return EventApiFp(configuration).upcoming(request, options)(fetch, basePath);
        },
    };
};
/**
 * EventApi - object-oriented interface
 * @export
 * @class EventApi
 * @extends {BaseAPI}
 */
export class EventApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    _delete(entityId, options) {
        return EventApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [importIdentifier]
     * @param {boolean} [createDependencies]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
        return EventApiFp(this.configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    addFavourite(request, options) {
        return EventApiFp(this.configuration).addFavourite(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentDeleteReport(entityId, options) {
        return EventApiFp(this.configuration).attendAbsentDeleteReport(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentListReport(request, options) {
        return EventApiFp(this.configuration).attendAbsentListReport(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentListReportForGroupType(request, options) {
        return EventApiFp(this.configuration).attendAbsentListReportForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     * The Filters collection will filter the Events, the property filters will filter Persons. Open events will not be listed as absence cannot be known for Open events. This only reports on person invited to an event who did NOT rsvp. To get a count of those who RSVPd but did not attend, use an Attendance report
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentRunReport(value, options) {
        return EventApiFp(this.configuration).attendAbsentRunReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentSaveReport(value, options) {
        return EventApiFp(this.configuration).attendAbsentSaveReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendAbsentSaveReportForGroupType(value, options) {
        return EventApiFp(this.configuration).attendAbsentSaveReportForGroupType(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendDeleteReport(entityId, options) {
        return EventApiFp(this.configuration).attendDeleteReport(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * Person unique code is ignored for this call, as it is not suppored from kiosk mode
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendGetForEventAndPerson(request, options) {
        return EventApiFp(this.configuration).attendGetForEventAndPerson(request, options)(this.fetch, this.basePath);
    }
    /**
     * The entity ID passed in should be for the group, not for a specific event. To get a specific event, use a filter.
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendListReport(request, options) {
        return EventApiFp(this.configuration).attendListReport(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendListReportForGroupType(request, options) {
        return EventApiFp(this.configuration).attendListReportForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendMaybe(request, options) {
        return EventApiFp(this.configuration).attendMaybe(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendNo(request, options) {
        return EventApiFp(this.configuration).attendNo(request, options)(this.fetch, this.basePath);
    }
    /**
     * The Filters collection will filter the Events
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendRunReport(value, options) {
        return EventApiFp(this.configuration).attendRunReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendSaveReport(value, options) {
        return EventApiFp(this.configuration).attendSaveReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendSaveReportForGroupType(value, options) {
        return EventApiFp(this.configuration).attendSaveReportForGroupType(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    attendYes(request, options) {
        return EventApiFp(this.configuration).attendYes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkIn(request, options) {
        return EventApiFp(this.configuration).checkIn(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventByCodeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkInByAttendanceCode(request, options) {
        return EventApiFp(this.configuration).checkInByAttendanceCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventByPersonRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkInByPersonCode(request, options) {
        return EventApiFp(this.configuration).checkInByPersonCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceMultipleRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkInMultiple(request, options) {
        return EventApiFp(this.configuration).checkInMultiple(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkOut(request, options) {
        return EventApiFp(this.configuration).checkOut(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventByCodeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkOutByAttendanceCode(request, options) {
        return EventApiFp(this.configuration).checkOutByAttendanceCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventByPersonRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkOutByPersonCode(request, options) {
        return EventApiFp(this.configuration).checkOutByPersonCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventAttendanceMultipleRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    checkOutMultiple(request, options) {
        return EventApiFp(this.configuration).checkOutMultiple(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    deleteResource(entityId, options) {
        return EventApiFp(this.configuration).deleteResource(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventDeleteReport(entityId, options) {
        return EventApiFp(this.configuration).eventDeleteReport(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventListReport(request, options) {
        return EventApiFp(this.configuration).eventListReport(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventListReportForGroupType(request, options) {
        return EventApiFp(this.configuration).eventListReportForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventRunReport(value, options) {
        return EventApiFp(this.configuration).eventRunReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventSaveReport(value, options) {
        return EventApiFp(this.configuration).eventSaveReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    eventSaveReportForGroupType(value, options) {
        return EventApiFp(this.configuration).eventSaveReportForGroupType(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    get(request, options) {
        return EventApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventByCodeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    getByCode(request, options) {
        return EventApiFp(this.configuration).getByCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    getFeedback(request, options) {
        return EventApiFp(this.configuration).getFeedback(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    getNote(request, options) {
        return EventApiFp(this.configuration).getNote(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    getResourceFile(request, options) {
        return EventApiFp(this.configuration).getResourceFile(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listAttendanceForEvent(request, options) {
        return EventApiFp(this.configuration).listAttendanceForEvent(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEventRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listForGroup(request, options) {
        return EventApiFp(this.configuration).listForGroup(request, options)(this.fetch, this.basePath);
    }
    /**
     * Lists possible attendees that are invited. Note that for open events this will return null/empty
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listInvited(request, options) {
        return EventApiFp(this.configuration).listInvited(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Lists all events that the current person can manage (write access). Note that this is 'as of now' and any date in the past is used as a start point rather than a point-in-time
     * @param {ApiRequestTo} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listManaged(request, options) {
        return EventApiFp(this.configuration).listManaged(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listNotes(request, options) {
        return EventApiFp(this.configuration).listNotes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} entityId
     * @param {Date} from
     * @param {Date} to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listOpen(entityId, from, to, options) {
        return EventApiFp(this.configuration).listOpen(entityId, from, to, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {Date} from
     * @param {Date} to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listOpenForHighlighted(from, to, options) {
        return EventApiFp(this.configuration).listOpenForHighlighted(from, to, options)(this.fetch, this.basePath);
    }
    /**
     * Lists possible attendees that you have rights to check in. For kiosk purposes, pass in the person unique code as well - current user will only be checked for Operate rights
     * @param {ApiPossibleAttendeeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listPossibleAttendees(request, options) {
        return EventApiFp(this.configuration).listPossibleAttendees(request, options)(this.fetch, this.basePath);
    }
    /**
     * All events that you (or those you own) are attending but not yet checked in to
     * @param {ApiRawPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listRegistered(request, options) {
        return EventApiFp(this.configuration).listRegistered(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    listResources(request, options) {
        return EventApiFp(this.configuration).listResources(request, options)(this.fetch, this.basePath);
    }
    /**
     * Before an occurrence of an event series can be used, it must be 'materialized' to turn it into a full event
     * @param {ApiEventMaterializeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    materialize(request, options) {
        return EventApiFp(this.configuration).materialize(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {EventPositionConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    position(value, options) {
        return EventApiFp(this.configuration).position(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionAccept(request, options) {
        return EventApiFp(this.configuration).positionAccept(request, options)(this.fetch, this.basePath);
    }
    /**
     * Leave the ToPersonEntityId blank to use the current person. You can only assign people to event positions, not event series positions
     * @param {EventPositionAssignConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionAssign(value, options) {
        return EventApiFp(this.configuration).positionAssign(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionAssigned(request, options) {
        return EventApiFp(this.configuration).positionAssigned(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionDelete(entityId, options) {
        return EventApiFp(this.configuration).positionDelete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionList(request, options) {
        return EventApiFp(this.configuration).positionList(request, options)(this.fetch, this.basePath);
    }
    /**
     * Deletes an event position assignment - can only be called by event writers/operators or the person themselves
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionUnassign(request, options) {
        return EventApiFp(this.configuration).positionUnassign(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Lists all event positions for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    positionUpcoming(request, options) {
        return EventApiFp(this.configuration).positionUpcoming(request, options)(this.fetch, this.basePath);
    }
    /**
     * Note that when materializing event series occurrences using this method, event positions will not be filled automatically.
     * @param {EventConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    post(value, options) {
        return EventApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddNoteRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    postNote(request, options) {
        return EventApiFp(this.configuration).postNote(request, options)(this.fetch, this.basePath);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [resourceJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
        return EventApiFp(this.configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(this.fetch, this.basePath);
    }
    /**
     * This runs a multiple attend yes
     * @param {ApiEventAttendanceMultipleRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    registerMultiple(request, options) {
        return EventApiFp(this.configuration).registerMultiple(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    restore(entityId, options) {
        return EventApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddReplyRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    saveFeedback(request, options) {
        return EventApiFp(this.configuration).saveFeedback(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary Lists all events for the current person for the next 2 months after the specified date. This is 'as of now' and any date in the past is used as a start point rather than a point-in-time
     * @param {ApiEventsUpcomingRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventApi
     */
    upcoming(request, options) {
        return EventApiFp(this.configuration).upcoming(request, options)(this.fetch, this.basePath);
    }
}
/**
 * EventSeriesApi - fetch parameter creator
 * @export
 */
export const EventSeriesApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/EventSeries`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options = {}) {
            const localVarPath = `/api/EventSeries/Favourite/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/EventSeries/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options = {}) {
            const localVarPath = `/api/EventSeries/Position`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventPositionConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options = {}) {
            const localVarPath = `/api/EventSeries/Position/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options = {}) {
            const localVarPath = `/api/EventSeries/Position/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EventSeriesConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/EventSeries`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventSeriesConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/EventSeries/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventSeriesApi - functional programming interface
 * @export
 */
export const EventSeriesApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).addFavourite(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).position(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).positionDelete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).positionList(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {EventSeriesConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = EventSeriesApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EventSeriesApi - factory interface
 * @export
 */
export const EventSeriesApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return EventSeriesApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            return EventSeriesApiFp(configuration).addFavourite(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return EventSeriesApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {EventPositionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        position(value, options) {
            return EventSeriesApiFp(configuration).position(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionDelete(entityId, options) {
            return EventSeriesApiFp(configuration).positionDelete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        positionList(request, options) {
            return EventSeriesApiFp(configuration).positionList(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {EventSeriesConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return EventSeriesApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return EventSeriesApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * EventSeriesApi - object-oriented interface
 * @export
 * @class EventSeriesApi
 * @extends {BaseAPI}
 */
export class EventSeriesApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    _delete(entityId, options) {
        return EventSeriesApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    addFavourite(request, options) {
        return EventSeriesApiFp(this.configuration).addFavourite(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    get(request, options) {
        return EventSeriesApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {EventPositionConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    position(value, options) {
        return EventSeriesApiFp(this.configuration).position(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    positionDelete(entityId, options) {
        return EventSeriesApiFp(this.configuration).positionDelete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    positionList(request, options) {
        return EventSeriesApiFp(this.configuration).positionList(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {EventSeriesConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    post(value, options) {
        return EventSeriesApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventSeriesApi
     */
    restore(entityId, options) {
        return EventSeriesApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * EventTypeApi - fetch parameter creator
 * @export
 */
export const EventTypeApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/EventType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/EventType/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options = {}) {
            const localVarPath = `/api/EventType/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityWithDeletedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {EventTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/EventType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("EventTypeConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/EventType/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * EventTypeApi - functional programming interface
 * @export
 */
export const EventTypeApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = EventTypeApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = EventTypeApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            const localVarFetchArgs = EventTypeApiFetchParamCreator(configuration).listForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {EventTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = EventTypeApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = EventTypeApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * EventTypeApi - factory interface
 * @export
 */
export const EventTypeApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return EventTypeApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return EventTypeApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            return EventTypeApiFp(configuration).listForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {EventTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return EventTypeApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return EventTypeApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * EventTypeApi - object-oriented interface
 * @export
 * @class EventTypeApi
 * @extends {BaseAPI}
 */
export class EventTypeApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    _delete(entityId, options) {
        return EventTypeApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    get(request, options) {
        return EventTypeApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityWithDeletedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    listForGroupType(request, options) {
        return EventTypeApiFp(this.configuration).listForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {EventTypeConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    post(value, options) {
        return EventTypeApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventTypeApi
     */
    restore(entityId, options) {
        return EventTypeApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * GroupApi - fetch parameter creator
 * @export
 */
export const GroupApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Group`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [entityId]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options = {}) {
            const localVarPath = `/api/Group/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            if (importIdentifier !== undefined) {
                localVarQueryParameter['importIdentifier'] = importIdentifier;
            }
            if (createDependencies !== undefined) {
                localVarQueryParameter['createDependencies'] = createDependencies;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options = {}) {
            const localVarPath = `/api/Group/Invite/Accept`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (secret !== undefined) {
                localVarQueryParameter['secret'] = secret;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options = {}) {
            const localVarPath = `/api/Group/Favourite/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Leave the 'ToPersonEntityId' blank to send to all members of this group
         * @param {NotificationConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(value, options = {}) {
            const localVarPath = `/api/Group/CreateNotification`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("NotificationConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options = {}) {
            const localVarPath = `/api/Group/Resource/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Group/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options = {}) {
            const localVarPath = `/api/Group/Note/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonNote(request, options = {}) {
            const localVarPath = `/api/Group/Note/Person/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options = {}) {
            const localVarPath = `/api/Group/Resource/File`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options = {}) {
            const localVarPath = `/api/Group/GetUsage`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Currently supports retrieval of up to 50 group records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get_1(request, options = {}) {
            const localVarPath = `/api/Group/GetMultiple`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityMultipleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDeleteReport(entityId, options = {}) {
            const localVarPath = `/api/Group/Report/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReport(request, options = {}) {
            const localVarPath = `/api/Group/Report/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReportForGroupType(request, options = {}) {
            const localVarPath = `/api/Group/Report/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRunReport(value, options = {}) {
            const localVarPath = `/api/Group/Report/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReport(value, options = {}) {
            const localVarPath = `/api/Group/Report/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReportForGroupType(value, options = {}) {
            const localVarPath = `/api/Group/Report/SaveForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {InviteConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(value, options = {}) {
            const localVarPath = `/api/Group/Invite`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("InviteConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroups(request, options = {}) {
            const localVarPath = `/api/Group/ListChildGroups`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Can only be called by Tenant Owners or Administrators
         * @summary Lists all descendants of a group
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendants(request, options = {}) {
            const localVarPath = `/api/Group/ListDescendants`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options = {}) {
            const localVarPath = `/api/Group/Note/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person's notes, use /api/Person/Note/List
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonNotes(request, options = {}) {
            const localVarPath = `/api/Group/Note/Person/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options = {}) {
            const localVarPath = `/api/Group/Resource/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroups(request, options = {}) {
            const localVarPath = `/api/Group/ListRootGroups`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedFilteredRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options = {}) {
            const localVarPath = `/api/Group/Lookup`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiSearchPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GroupConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Group`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GroupConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options = {}) {
            const localVarPath = `/api/Group/Note`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddNoteRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddNotePersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPersonNote(request, options = {}) {
            const localVarPath = `/api/Group/Note/Person`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddNotePersonRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options = {}) {
            const localVarPath = `/api/Group/Resource/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (resourceJson !== undefined) {
                localVarQueryParameter['resourceJson'] = resourceJson;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Group/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options = {}) {
            const localVarPath = `/api/Group/SearchReIndex`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options = {}) {
            const localVarPath = `/api/Group/SetSecurity`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiSecurityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiSubscriptionUpdateRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(request, options = {}) {
            const localVarPath = `/api/Group/UpdateSubscription`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiSubscriptionUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [entityId]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).acceptInvite(secret, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).addFavourite(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Leave the 'ToPersonEntityId' blank to send to all members of this group
         * @param {NotificationConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).createNotification(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).deleteResource(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).getNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonNote(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).getPersonNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).getResourceFile(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).getUsage(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Currently supports retrieval of up to 50 group records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get_1(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).get_1(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDeleteReport(entityId, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupDeleteReport(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReport(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupListReport(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReportForGroupType(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupListReportForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRunReport(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupRunReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReport(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupSaveReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReportForGroupType(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).groupSaveReportForGroupType(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {InviteConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).invite(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroups(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listChildGroups(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Can only be called by Tenant Owners or Administrators
         * @summary Lists all descendants of a group
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendants(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listDescendants(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listNotes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person's notes, use /api/Person/Note/List
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonNotes(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listPersonNotes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listResources(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroups(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).listRootGroups(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).lookup(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {GroupConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).postNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddNotePersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPersonNote(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).postPersonNote(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).searchReIndex(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).setSecurity(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiSubscriptionUpdateRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(request, options) {
            const localVarFetchArgs = GroupApiFetchParamCreator(configuration).updateSubscription(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return GroupApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [entityId]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options) {
            return GroupApiFp(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options) {
            return GroupApiFp(configuration).acceptInvite(secret, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            return GroupApiFp(configuration).addFavourite(request, options)(fetch, basePath);
        },
        /**
         * Leave the 'ToPersonEntityId' blank to send to all members of this group
         * @param {NotificationConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNotification(value, options) {
            return GroupApiFp(configuration).createNotification(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            return GroupApiFp(configuration).deleteResource(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return GroupApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNote(request, options) {
            return GroupApiFp(configuration).getNote(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPersonNote(request, options) {
            return GroupApiFp(configuration).getPersonNote(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            return GroupApiFp(configuration).getResourceFile(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options) {
            return GroupApiFp(configuration).getUsage(request, options)(fetch, basePath);
        },
        /**
         * Currently supports retrieval of up to 50 group records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get_1(request, options) {
            return GroupApiFp(configuration).get_1(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupDeleteReport(entityId, options) {
            return GroupApiFp(configuration).groupDeleteReport(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReport(request, options) {
            return GroupApiFp(configuration).groupListReport(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupListReportForGroupType(request, options) {
            return GroupApiFp(configuration).groupListReportForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupRunReport(value, options) {
            return GroupApiFp(configuration).groupRunReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReport(value, options) {
            return GroupApiFp(configuration).groupSaveReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        groupSaveReportForGroupType(value, options) {
            return GroupApiFp(configuration).groupSaveReportForGroupType(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {InviteConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(value, options) {
            return GroupApiFp(configuration).invite(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroups(request, options) {
            return GroupApiFp(configuration).listChildGroups(request, options)(fetch, basePath);
        },
        /**
         * Can only be called by Tenant Owners or Administrators
         * @summary Lists all descendants of a group
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendants(request, options) {
            return GroupApiFp(configuration).listDescendants(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            return GroupApiFp(configuration).listNotes(request, options)(fetch, basePath);
        },
        /**
         * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person's notes, use /api/Person/Note/List
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPersonNotes(request, options) {
            return GroupApiFp(configuration).listPersonNotes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            return GroupApiFp(configuration).listResources(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroups(request, options) {
            return GroupApiFp(configuration).listRootGroups(request, options)(fetch, basePath);
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options) {
            return GroupApiFp(configuration).lookup(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {GroupConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return GroupApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddNoteRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postNote(request, options) {
            return GroupApiFp(configuration).postNote(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddNotePersonRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postPersonNote(request, options) {
            return GroupApiFp(configuration).postPersonNote(request, options)(fetch, basePath);
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            return GroupApiFp(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return GroupApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options) {
            return GroupApiFp(configuration).searchReIndex(options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options) {
            return GroupApiFp(configuration).setSecurity(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiSubscriptionUpdateRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubscription(request, options) {
            return GroupApiFp(configuration).updateSubscription(request, options)(fetch, basePath);
        },
    };
};
/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    _delete(entityId, options) {
        return GroupApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [entityId]
     * @param {string} [importIdentifier]
     * @param {boolean} [createDependencies]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    _import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options) {
        return GroupApiFp(this.configuration)._import(contentType, contentDisposition, headers, length, name, fileName, entityId, importIdentifier, createDependencies, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    acceptInvite(secret, options) {
        return GroupApiFp(this.configuration).acceptInvite(secret, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    addFavourite(request, options) {
        return GroupApiFp(this.configuration).addFavourite(request, options)(this.fetch, this.basePath);
    }
    /**
     * Leave the 'ToPersonEntityId' blank to send to all members of this group
     * @param {NotificationConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    createNotification(value, options) {
        return GroupApiFp(this.configuration).createNotification(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    deleteResource(entityId, options) {
        return GroupApiFp(this.configuration).deleteResource(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    get(request, options) {
        return GroupApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getNote(request, options) {
        return GroupApiFp(this.configuration).getNote(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getPersonNote(request, options) {
        return GroupApiFp(this.configuration).getPersonNote(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getResourceFile(request, options) {
        return GroupApiFp(this.configuration).getResourceFile(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    getUsage(request, options) {
        return GroupApiFp(this.configuration).getUsage(request, options)(this.fetch, this.basePath);
    }
    /**
     * Currently supports retrieval of up to 50 group records at once
     * @param {ApiEntityMultipleRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    get_1(request, options) {
        return GroupApiFp(this.configuration).get_1(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupDeleteReport(entityId, options) {
        return GroupApiFp(this.configuration).groupDeleteReport(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupListReport(request, options) {
        return GroupApiFp(this.configuration).groupListReport(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupListReportForGroupType(request, options) {
        return GroupApiFp(this.configuration).groupListReportForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupRunReport(value, options) {
        return GroupApiFp(this.configuration).groupRunReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupSaveReport(value, options) {
        return GroupApiFp(this.configuration).groupSaveReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    groupSaveReportForGroupType(value, options) {
        return GroupApiFp(this.configuration).groupSaveReportForGroupType(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {InviteConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    invite(value, options) {
        return GroupApiFp(this.configuration).invite(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listChildGroups(request, options) {
        return GroupApiFp(this.configuration).listChildGroups(request, options)(this.fetch, this.basePath);
    }
    /**
     * Can only be called by Tenant Owners or Administrators
     * @summary Lists all descendants of a group
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listDescendants(request, options) {
        return GroupApiFp(this.configuration).listDescendants(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listNotes(request, options) {
        return GroupApiFp(this.configuration).listNotes(request, options)(this.fetch, this.basePath);
    }
    /**
     * Note that this lists all the notes for all persons for the specified group, not all the notes for a person. For a person's notes, use /api/Person/Note/List
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listPersonNotes(request, options) {
        return GroupApiFp(this.configuration).listPersonNotes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listResources(request, options) {
        return GroupApiFp(this.configuration).listResources(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiPagedFilteredRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    listRootGroups(request, options) {
        return GroupApiFp(this.configuration).listRootGroups(request, options)(this.fetch, this.basePath);
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {ApiSearchPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    lookup(request, options) {
        return GroupApiFp(this.configuration).lookup(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {GroupConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    post(value, options) {
        return GroupApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddNoteRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    postNote(request, options) {
        return GroupApiFp(this.configuration).postNote(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddNotePersonRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    postPersonNote(request, options) {
        return GroupApiFp(this.configuration).postPersonNote(request, options)(this.fetch, this.basePath);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [resourceJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
        return GroupApiFp(this.configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    restore(entityId, options) {
        return GroupApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    searchReIndex(options) {
        return GroupApiFp(this.configuration).searchReIndex(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiSecurityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    setSecurity(request, options) {
        return GroupApiFp(this.configuration).setSecurity(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiSubscriptionUpdateRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    updateSubscription(request, options) {
        return GroupApiFp(this.configuration).updateSubscription(request, options)(this.fetch, this.basePath);
    }
}
/**
 * GroupTypeApi - fetch parameter creator
 * @export
 */
export const GroupTypeApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/GroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTemplate(request, options = {}) {
            const localVarPath = `/api/GroupType/ExportTemplate`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/GroupType/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroupTypes(request, options = {}) {
            const localVarPath = `/api/GroupType/ListChildGroupTypes`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendantGroupTypes(request, options = {}) {
            const localVarPath = `/api/GroupType/ListDescendants`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroupTypes(request, options = {}) {
            const localVarPath = `/api/GroupType/ListRootGroupTypes`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiFilteredRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {GroupTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/GroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("GroupTypeConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/GroupType/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options = {}) {
            const localVarPath = `/api/GroupType/SetSecurity`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiSecurityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * GroupTypeApi - functional programming interface
 * @export
 */
export const GroupTypeApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTemplate(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).exportTemplate(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroupTypes(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).listChildGroupTypes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendantGroupTypes(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).listDescendantGroupTypes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroupTypes(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).listRootGroupTypes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {GroupTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options) {
            const localVarFetchArgs = GroupTypeApiFetchParamCreator(configuration).setSecurity(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * GroupTypeApi - factory interface
 * @export
 */
export const GroupTypeApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return GroupTypeApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        exportTemplate(request, options) {
            return GroupTypeApiFp(configuration).exportTemplate(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return GroupTypeApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChildGroupTypes(request, options) {
            return GroupTypeApiFp(configuration).listChildGroupTypes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDescendantGroupTypes(request, options) {
            return GroupTypeApiFp(configuration).listDescendantGroupTypes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRootGroupTypes(request, options) {
            return GroupTypeApiFp(configuration).listRootGroupTypes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {GroupTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return GroupTypeApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return GroupTypeApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiSecurityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setSecurity(request, options) {
            return GroupTypeApiFp(configuration).setSecurity(request, options)(fetch, basePath);
        },
    };
};
/**
 * GroupTypeApi - object-oriented interface
 * @export
 * @class GroupTypeApi
 * @extends {BaseAPI}
 */
export class GroupTypeApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    _delete(entityId, options) {
        return GroupTypeApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    exportTemplate(request, options) {
        return GroupTypeApiFp(this.configuration).exportTemplate(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    get(request, options) {
        return GroupTypeApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    listChildGroupTypes(request, options) {
        return GroupTypeApiFp(this.configuration).listChildGroupTypes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    listDescendantGroupTypes(request, options) {
        return GroupTypeApiFp(this.configuration).listDescendantGroupTypes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiFilteredRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    listRootGroupTypes(request, options) {
        return GroupTypeApiFp(this.configuration).listRootGroupTypes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {GroupTypeConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    post(value, options) {
        return GroupTypeApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    restore(entityId, options) {
        return GroupTypeApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiSecurityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupTypeApi
     */
    setSecurity(request, options) {
        return GroupTypeApiFp(this.configuration).setSecurity(request, options)(this.fetch, this.basePath);
    }
}
/**
 * ImportApi - fetch parameter creator
 * @export
 */
export const ImportApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(entityId, options = {}) {
            const localVarPath = `/api/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ImportApi - functional programming interface
 * @export
 */
export const ImportApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(entityId, options) {
            const localVarFetchArgs = ImportApiFetchParamCreator(configuration).get(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * ImportApi - factory interface
 * @export
 */
export const ImportApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(entityId, options) {
            return ImportApiFp(configuration).get(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * ImportApi - object-oriented interface
 * @export
 * @class ImportApi
 * @extends {BaseAPI}
 */
export class ImportApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImportApi
     */
    get(entityId, options) {
        return ImportApiFp(this.configuration).get(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * NoteApi - fetch parameter creator
 * @export
 */
export const NoteApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(request, options = {}) {
            const localVarPath = `/api/Note/Edit`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddReplyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Note/Reply/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplies(request, options = {}) {
            const localVarPath = `/api/Note/Reply/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reply(request, options = {}) {
            const localVarPath = `/api/Note/Reply`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddReplyRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NoteApi - functional programming interface
 * @export
 */
export const NoteApiFp = function (configuration) {
    return {
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(request, options) {
            const localVarFetchArgs = NoteApiFetchParamCreator(configuration).edit(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = NoteApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplies(request, options) {
            const localVarFetchArgs = NoteApiFetchParamCreator(configuration).listReplies(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reply(request, options) {
            const localVarFetchArgs = NoteApiFetchParamCreator(configuration).reply(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * NoteApi - factory interface
 * @export
 */
export const NoteApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        edit(request, options) {
            return NoteApiFp(configuration).edit(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return NoteApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listReplies(request, options) {
            return NoteApiFp(configuration).listReplies(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddReplyRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reply(request, options) {
            return NoteApiFp(configuration).reply(request, options)(fetch, basePath);
        },
    };
};
/**
 * NoteApi - object-oriented interface
 * @export
 * @class NoteApi
 * @extends {BaseAPI}
 */
export class NoteApi extends BaseAPI {
    /**
     *
     * @param {ApiAddReplyRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    edit(request, options) {
        return NoteApiFp(this.configuration).edit(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    get(request, options) {
        return NoteApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    listReplies(request, options) {
        return NoteApiFp(this.configuration).listReplies(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddReplyRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NoteApi
     */
    reply(request, options) {
        return NoteApiFp(this.configuration).reply(request, options)(this.fetch, this.basePath);
    }
}
/**
 * NotificationApi - fetch parameter creator
 * @export
 */
export const NotificationApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {ApiRemoteNotificationRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(request, options = {}) {
            const localVarPath = `/api/Notification/GetNotification`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRemoteNotificationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * NotificationApi - functional programming interface
 * @export
 */
export const NotificationApiFp = function (configuration) {
    return {
        /**
         *
         * @param {ApiRemoteNotificationRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(request, options) {
            const localVarFetchArgs = NotificationApiFetchParamCreator(configuration).getNotification(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * NotificationApi - factory interface
 * @export
 */
export const NotificationApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {ApiRemoteNotificationRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotification(request, options) {
            return NotificationApiFp(configuration).getNotification(request, options)(fetch, basePath);
        },
    };
};
/**
 * NotificationApi - object-oriented interface
 * @export
 * @class NotificationApi
 * @extends {BaseAPI}
 */
export class NotificationApi extends BaseAPI {
    /**
     *
     * @param {ApiRemoteNotificationRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NotificationApi
     */
    getNotification(request, options) {
        return NotificationApiFp(this.configuration).getNotification(request, options)(this.fetch, this.basePath);
    }
}
/**
 * PersonApi - fetch parameter creator
 * @export
 */
export const PersonApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Person`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options = {}) {
            const localVarPath = `/api/Person/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (importIdentifier !== undefined) {
                localVarQueryParameter['importIdentifier'] = importIdentifier;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptGroupMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Accept`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options = {}) {
            const localVarPath = `/api/Person/Invite/Accept`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (secret !== undefined) {
                localVarQueryParameter['secret'] = secret;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate(request, options = {}) {
            const localVarPath = `/api/Person/Activate`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateGroupMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Activate`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options = {}) {
            const localVarPath = `/api/Person/Favourite/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupTypeMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/GroupType/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivate(request, options = {}) {
            const localVarPath = `/api/Person/Deactivate`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateGroupMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Deactivate`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options = {}) {
            const localVarPath = `/api/Person/Resource/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Person/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Currently supports retrieval of up to 50 person records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiple(request, options = {}) {
            const localVarPath = `/api/Person/GetMultiple`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityMultipleRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options = {}) {
            const localVarPath = `/api/Person/Resource/File`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options = {}) {
            const localVarPath = `/api/Person/GetSelf`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiHistoryRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        history(request, options = {}) {
            const localVarPath = `/api/Person/History`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiHistoryRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (importIdentifier !== undefined) {
                localVarQueryParameter['importIdentifier'] = importIdentifier;
            }
            if (createDependencies !== undefined) {
                localVarQueryParameter['createDependencies'] = createDependencies;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This sends an invite to this person to take ownership of this person record.
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(request, options = {}) {
            const localVarPath = `/api/Person/Invite`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAllMatching(request, options = {}) {
            const localVarPath = `/api/Person/Invite/AllMatching`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiForgottenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This sends an invite to the person with this email address.
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteByEmail(email, options = {}) {
            const localVarPath = `/api/Person/Invite/Email`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options = {}) {
            const localVarPath = `/api/Person/ListForGroup`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options = {}) {
            const localVarPath = `/api/Person/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInactive(request, options = {}) {
            const localVarPath = `/api/Person/ListInactive`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options = {}) {
            const localVarPath = `/api/Person/Note/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityWithDeletedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options = {}) {
            const localVarPath = `/api/Person/Resource/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options = {}) {
            const localVarPath = `/api/Person/Lookup`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiSearchPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipDeleteReport(entityId, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportDelete(entityId, options = {}) {
            const localVarPath = `/api/Person/Membership/Export/Delete`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        membershipExportList(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Export/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Note that the fields property is for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportRun(value, options = {}) {
            const localVarPath = `/api/Person/Membership/Export/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MembershipExportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportSave(value, options = {}) {
            const localVarPath = `/api/Person/Membership/Export/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("MembershipExportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReport(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReportForGroupType(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The Filters collection will filter the Roles, the property filters will filter the Persons
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipRunReport(value, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/Run`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReport(value, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReportForGroupType(value, options = {}) {
            const localVarPath = `/api/Person/Membership/Report/SaveForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ReportConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsIn(request, options = {}) {
            const localVarPath = `/api/Person/Notifications/In`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsOut(request, options = {}) {
            const localVarPath = `/api/Person/Notifications/Out`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        owned(request, options = {}) {
            const localVarPath = `/api/Person/Owner/ListOwned`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedFilteredRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApprove(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Approve`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApproved(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Approved`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDecline(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Decline`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDeclined(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Declined`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestExpired(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Expired`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestPending(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request/Pending`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {PersonConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Person`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("PersonConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person's resources)
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options = {}) {
            const localVarPath = `/api/Person/Resource/Save`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (resourceJson !== undefined) {
                localVarQueryParameter['resourceJson'] = resourceJson;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Recreates the unique code for a person which can be used to, for example, check in for an event
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateUniqueCode(request, options = {}) {
            const localVarPath = `/api/Person/RecreateUniqueCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/Group/Remove`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupTypeMembership(request, options = {}) {
            const localVarPath = `/api/Person/Membership/GroupType/Remove`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiMembershipRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The entity ID passed in is the person you wish to request ownership of
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOwnership(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Request`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Person/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options = {}) {
            const localVarPath = `/api/Person/SearchReIndex`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUniqueCode(request, options = {}) {
            const localVarPath = `/api/Person/SendUniqueCode`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiForgottenRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiAddOwnerRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnership(request, options = {}) {
            const localVarPath = `/api/Person/Owner/Add`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiAddOwnerRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Wipes a person's sensitive personal details. CANNOT BE REVERSED.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wipe(request, options = {}) {
            const localVarPath = `/api/Person/Wipe`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * PersonApi - functional programming interface
 * @export
 */
export const PersonApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptGroupMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).acceptGroupMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).acceptInvite(secret, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).activate(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateGroupMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).activateGroupMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).addFavourite(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).addGroupMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupTypeMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).addGroupTypeMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivate(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).deactivate(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateGroupMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).deactivateGroupMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).deleteResource(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Currently supports retrieval of up to 50 person records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiple(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).getMultiple(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).getResourceFile(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).getSelf(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiHistoryRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        history(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).history(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This sends an invite to this person to take ownership of this person record.
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).invite(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAllMatching(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).inviteAllMatching(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This sends an invite to the person with this email address.
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteByEmail(email, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).inviteByEmail(email, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).listForGroup(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).listForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInactive(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).listInactive(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).listNotes(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).listResources(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).lookup(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipDeleteReport(entityId, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipDeleteReport(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportDelete(entityId, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipExportDelete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        membershipExportList(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipExportList(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Note that the fields property is for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportRun(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipExportRun(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportSave(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipExportSave(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReport(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipListReport(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReportForGroupType(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipListReportForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The Filters collection will filter the Roles, the property filters will filter the Persons
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipRunReport(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipRunReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReport(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipSaveReport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReportForGroupType(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).membershipSaveReportForGroupType(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsIn(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).notificationsIn(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsOut(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).notificationsOut(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        owned(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).owned(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApprove(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestApprove(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApproved(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestApproved(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDecline(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestDecline(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDeclined(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestDeclined(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestExpired(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestExpired(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestPending(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).ownershipRequestPending(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {PersonConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person's resources)
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Recreates the unique code for a person which can be used to, for example, check in for an event
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateUniqueCode(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).recreateUniqueCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).removeGroupMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupTypeMembership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).removeGroupTypeMembership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The entity ID passed in is the person you wish to request ownership of
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOwnership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).requestOwnership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).searchReIndex(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUniqueCode(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).sendUniqueCode(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiAddOwnerRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnership(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).transferOwnership(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Wipes a person's sensitive personal details. CANNOT BE REVERSED.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wipe(request, options) {
            const localVarFetchArgs = PersonApiFetchParamCreator(configuration).wipe(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * PersonApi - factory interface
 * @export
 */
export const PersonApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return PersonApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options) {
            return PersonApiFp(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptGroupMembership(request, options) {
            return PersonApiFp(configuration).acceptGroupMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [secret]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptInvite(secret, options) {
            return PersonApiFp(configuration).acceptInvite(secret, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activate(request, options) {
            return PersonApiFp(configuration).activate(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        activateGroupMembership(request, options) {
            return PersonApiFp(configuration).activateGroupMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addFavourite(request, options) {
            return PersonApiFp(configuration).addFavourite(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupMembership(request, options) {
            return PersonApiFp(configuration).addGroupMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGroupTypeMembership(request, options) {
            return PersonApiFp(configuration).addGroupTypeMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivate(request, options) {
            return PersonApiFp(configuration).deactivate(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deactivateGroupMembership(request, options) {
            return PersonApiFp(configuration).deactivateGroupMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteResource(entityId, options) {
            return PersonApiFp(configuration).deleteResource(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return PersonApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         * Currently supports retrieval of up to 50 person records at once
         * @param {ApiEntityMultipleRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMultiple(request, options) {
            return PersonApiFp(configuration).getMultiple(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResourceFile(request, options) {
            return PersonApiFp(configuration).getResourceFile(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options) {
            return PersonApiFp(configuration).getSelf(options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiHistoryRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        history(request, options) {
            return PersonApiFp(configuration).history(request, options)(fetch, basePath);
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            return PersonApiFp(configuration).importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(fetch, basePath);
        },
        /**
         * This sends an invite to this person to take ownership of this person record.
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invite(request, options) {
            return PersonApiFp(configuration).invite(request, options)(fetch, basePath);
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteAllMatching(request, options) {
            return PersonApiFp(configuration).inviteAllMatching(request, options)(fetch, basePath);
        },
        /**
         * This sends an invite to the person with this email address.
         * @param {string} [email]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteByEmail(email, options) {
            return PersonApiFp(configuration).inviteByEmail(email, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroup(request, options) {
            return PersonApiFp(configuration).listForGroup(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            return PersonApiFp(configuration).listForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInactive(request, options) {
            return PersonApiFp(configuration).listInactive(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listNotes(request, options) {
            return PersonApiFp(configuration).listNotes(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listResources(request, options) {
            return PersonApiFp(configuration).listResources(request, options)(fetch, basePath);
        },
        /**
         * Note that the Order and Sort are ignored for this call as it is ordered by ranking
         * @param {ApiSearchPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        lookup(request, options) {
            return PersonApiFp(configuration).lookup(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipDeleteReport(entityId, options) {
            return PersonApiFp(configuration).membershipDeleteReport(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportDelete(entityId, options) {
            return PersonApiFp(configuration).membershipExportDelete(entityId, options)(fetch, basePath);
        },
        /**
         * Lists all membership export definitions for the given group
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportList(request, options) {
            return PersonApiFp(configuration).membershipExportList(request, options)(fetch, basePath);
        },
        /**
         * Note that the fields property is for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportRun(value, options) {
            return PersonApiFp(configuration).membershipExportRun(value, options)(fetch, basePath);
        },
        /**
         * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
         * @param {MembershipExportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipExportSave(value, options) {
            return PersonApiFp(configuration).membershipExportSave(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReport(request, options) {
            return PersonApiFp(configuration).membershipListReport(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipListReportForGroupType(request, options) {
            return PersonApiFp(configuration).membershipListReportForGroupType(request, options)(fetch, basePath);
        },
        /**
         * The Filters collection will filter the Roles, the property filters will filter the Persons
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipRunReport(value, options) {
            return PersonApiFp(configuration).membershipRunReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReport(value, options) {
            return PersonApiFp(configuration).membershipSaveReport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ReportConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        membershipSaveReportForGroupType(value, options) {
            return PersonApiFp(configuration).membershipSaveReportForGroupType(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsIn(request, options) {
            return PersonApiFp(configuration).notificationsIn(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationsOut(request, options) {
            return PersonApiFp(configuration).notificationsOut(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiPagedFilteredRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        owned(request, options) {
            return PersonApiFp(configuration).owned(request, options)(fetch, basePath);
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApprove(request, options) {
            return PersonApiFp(configuration).ownershipRequestApprove(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestApproved(request, options) {
            return PersonApiFp(configuration).ownershipRequestApproved(request, options)(fetch, basePath);
        },
        /**
         * The entity ID passed in is the owner request entity ID
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDecline(request, options) {
            return PersonApiFp(configuration).ownershipRequestDecline(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestDeclined(request, options) {
            return PersonApiFp(configuration).ownershipRequestDeclined(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestExpired(request, options) {
            return PersonApiFp(configuration).ownershipRequestExpired(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ownershipRequestPending(request, options) {
            return PersonApiFp(configuration).ownershipRequestPending(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {PersonConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return PersonApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person's resources)
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [resourceJson]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
            return PersonApiFp(configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(fetch, basePath);
        },
        /**
         * Recreates the unique code for a person which can be used to, for example, check in for an event
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recreateUniqueCode(request, options) {
            return PersonApiFp(configuration).recreateUniqueCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupMembership(request, options) {
            return PersonApiFp(configuration).removeGroupMembership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiMembershipRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGroupTypeMembership(request, options) {
            return PersonApiFp(configuration).removeGroupTypeMembership(request, options)(fetch, basePath);
        },
        /**
         * The entity ID passed in is the person you wish to request ownership of
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        requestOwnership(request, options) {
            return PersonApiFp(configuration).requestOwnership(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return PersonApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchReIndex(options) {
            return PersonApiFp(configuration).searchReIndex(options)(fetch, basePath);
        },
        /**
         * Sends the unique code for a person to their stored contact details
         * @param {ApiForgottenRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendUniqueCode(request, options) {
            return PersonApiFp(configuration).sendUniqueCode(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiAddOwnerRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferOwnership(request, options) {
            return PersonApiFp(configuration).transferOwnership(request, options)(fetch, basePath);
        },
        /**
         * Wipes a person's sensitive personal details. CANNOT BE REVERSED.
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        wipe(request, options) {
            return PersonApiFp(configuration).wipe(request, options)(fetch, basePath);
        },
    };
};
/**
 * PersonApi - object-oriented interface
 * @export
 * @class PersonApi
 * @extends {BaseAPI}
 */
export class PersonApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    _delete(entityId, options) {
        return PersonApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [importIdentifier]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options) {
        return PersonApiFp(this.configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    acceptGroupMembership(request, options) {
        return PersonApiFp(this.configuration).acceptGroupMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [secret]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    acceptInvite(secret, options) {
        return PersonApiFp(this.configuration).acceptInvite(secret, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    activate(request, options) {
        return PersonApiFp(this.configuration).activate(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    activateGroupMembership(request, options) {
        return PersonApiFp(this.configuration).activateGroupMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    addFavourite(request, options) {
        return PersonApiFp(this.configuration).addFavourite(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    addGroupMembership(request, options) {
        return PersonApiFp(this.configuration).addGroupMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    addGroupTypeMembership(request, options) {
        return PersonApiFp(this.configuration).addGroupTypeMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    deactivate(request, options) {
        return PersonApiFp(this.configuration).deactivate(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    deactivateGroupMembership(request, options) {
        return PersonApiFp(this.configuration).deactivateGroupMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    deleteResource(entityId, options) {
        return PersonApiFp(this.configuration).deleteResource(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    get(request, options) {
        return PersonApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     * Currently supports retrieval of up to 50 person records at once
     * @param {ApiEntityMultipleRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    getMultiple(request, options) {
        return PersonApiFp(this.configuration).getMultiple(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    getResourceFile(request, options) {
        return PersonApiFp(this.configuration).getResourceFile(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    getSelf(options) {
        return PersonApiFp(this.configuration).getSelf(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiHistoryRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    history(request, options) {
        return PersonApiFp(this.configuration).history(request, options)(this.fetch, this.basePath);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [importIdentifier]
     * @param {boolean} [createDependencies]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
        return PersonApiFp(this.configuration).importMemberships(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(this.fetch, this.basePath);
    }
    /**
     * This sends an invite to this person to take ownership of this person record.
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    invite(request, options) {
        return PersonApiFp(this.configuration).invite(request, options)(this.fetch, this.basePath);
    }
    /**
     * Sends the unique code for a person to their stored contact details
     * @param {ApiForgottenRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    inviteAllMatching(request, options) {
        return PersonApiFp(this.configuration).inviteAllMatching(request, options)(this.fetch, this.basePath);
    }
    /**
     * This sends an invite to the person with this email address.
     * @param {string} [email]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    inviteByEmail(email, options) {
        return PersonApiFp(this.configuration).inviteByEmail(email, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    listForGroup(request, options) {
        return PersonApiFp(this.configuration).listForGroup(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    listForGroupType(request, options) {
        return PersonApiFp(this.configuration).listForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    listInactive(request, options) {
        return PersonApiFp(this.configuration).listInactive(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityWithDeletedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    listNotes(request, options) {
        return PersonApiFp(this.configuration).listNotes(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    listResources(request, options) {
        return PersonApiFp(this.configuration).listResources(request, options)(this.fetch, this.basePath);
    }
    /**
     * Note that the Order and Sort are ignored for this call as it is ordered by ranking
     * @param {ApiSearchPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    lookup(request, options) {
        return PersonApiFp(this.configuration).lookup(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipDeleteReport(entityId, options) {
        return PersonApiFp(this.configuration).membershipDeleteReport(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipExportDelete(entityId, options) {
        return PersonApiFp(this.configuration).membershipExportDelete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * Lists all membership export definitions for the given group
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipExportList(request, options) {
        return PersonApiFp(this.configuration).membershipExportList(request, options)(this.fetch, this.basePath);
    }
    /**
     * Note that the fields property is for client usage, and do not affect the fields returned.
     * @param {MembershipExportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipExportRun(value, options) {
        return PersonApiFp(this.configuration).membershipExportRun(value, options)(this.fetch, this.basePath);
    }
    /**
     * Saves a membership export definition for the given group. Note that the fields property is simply storage for client usage, and do not affect the fields returned.
     * @param {MembershipExportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipExportSave(value, options) {
        return PersonApiFp(this.configuration).membershipExportSave(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipListReport(request, options) {
        return PersonApiFp(this.configuration).membershipListReport(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipListReportForGroupType(request, options) {
        return PersonApiFp(this.configuration).membershipListReportForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     * The Filters collection will filter the Roles, the property filters will filter the Persons
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipRunReport(value, options) {
        return PersonApiFp(this.configuration).membershipRunReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipSaveReport(value, options) {
        return PersonApiFp(this.configuration).membershipSaveReport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ReportConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    membershipSaveReportForGroupType(value, options) {
        return PersonApiFp(this.configuration).membershipSaveReportForGroupType(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    notificationsIn(request, options) {
        return PersonApiFp(this.configuration).notificationsIn(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    notificationsOut(request, options) {
        return PersonApiFp(this.configuration).notificationsOut(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiPagedFilteredRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    owned(request, options) {
        return PersonApiFp(this.configuration).owned(request, options)(this.fetch, this.basePath);
    }
    /**
     * The entity ID passed in is the owner request entity ID
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestApprove(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestApprove(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestApproved(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestApproved(request, options)(this.fetch, this.basePath);
    }
    /**
     * The entity ID passed in is the owner request entity ID
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestDecline(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestDecline(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestDeclined(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestDeclined(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestExpired(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestExpired(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    ownershipRequestPending(request, options) {
        return PersonApiFp(this.configuration).ownershipRequestPending(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {PersonConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    post(value, options) {
        return PersonApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     * Pass in a multipart form with two parameters: file [File] and resourceJson [Text], with the resourceJson holding a ResourceConstruct (note that the Limit.IsOpen is the only security that is checked for a Person's resources)
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [resourceJson]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options) {
        return PersonApiFp(this.configuration).postResource(contentType, contentDisposition, headers, length, name, fileName, resourceJson, options)(this.fetch, this.basePath);
    }
    /**
     * Recreates the unique code for a person which can be used to, for example, check in for an event
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    recreateUniqueCode(request, options) {
        return PersonApiFp(this.configuration).recreateUniqueCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    removeGroupMembership(request, options) {
        return PersonApiFp(this.configuration).removeGroupMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiMembershipRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    removeGroupTypeMembership(request, options) {
        return PersonApiFp(this.configuration).removeGroupTypeMembership(request, options)(this.fetch, this.basePath);
    }
    /**
     * The entity ID passed in is the person you wish to request ownership of
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    requestOwnership(request, options) {
        return PersonApiFp(this.configuration).requestOwnership(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    restore(entityId, options) {
        return PersonApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    searchReIndex(options) {
        return PersonApiFp(this.configuration).searchReIndex(options)(this.fetch, this.basePath);
    }
    /**
     * Sends the unique code for a person to their stored contact details
     * @param {ApiForgottenRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    sendUniqueCode(request, options) {
        return PersonApiFp(this.configuration).sendUniqueCode(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiAddOwnerRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    transferOwnership(request, options) {
        return PersonApiFp(this.configuration).transferOwnership(request, options)(this.fetch, this.basePath);
    }
    /**
     * Wipes a person's sensitive personal details. CANNOT BE REVERSED.
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonApi
     */
    wipe(request, options) {
        return PersonApiFp(this.configuration).wipe(request, options)(this.fetch, this.basePath);
    }
}
/**
 * RelationshipApi - fetch parameter creator
 * @export
 */
export const RelationshipApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Relationship`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options = {}) {
            const localVarPath = `/api/Relationship/Import`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (contentType !== undefined) {
                localVarQueryParameter['ContentType'] = contentType;
            }
            if (contentDisposition !== undefined) {
                localVarQueryParameter['ContentDisposition'] = contentDisposition;
            }
            if (headers !== undefined) {
                localVarQueryParameter['Headers'] = headers;
            }
            if (length !== undefined) {
                localVarQueryParameter['Length'] = length;
            }
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            if (fileName !== undefined) {
                localVarQueryParameter['FileName'] = fileName;
            }
            if (importIdentifier !== undefined) {
                localVarQueryParameter['importIdentifier'] = importIdentifier;
            }
            if (createDependencies !== undefined) {
                localVarQueryParameter['createDependencies'] = createDependencies;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept(value, options = {}) {
            const localVarPath = `/api/Relationship/Accept`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept_1(value, options = {}) {
            // verify required parameter 'value' is not null or undefined
            if (value === null || value === undefined) {
                throw new RequiredError('value', 'Required parameter value was null or undefined when calling accept_1.');
            }
            const localVarPath = `/api/Relationship/Accept/{value}`
                .replace(`{${"value"}}`, encodeURIComponent(String(value)));
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Relationship/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwned(request, options = {}) {
            const localVarPath = `/api/Relationship/Owned/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwnedAwaitingAcceptance(request, options = {}) {
            const localVarPath = `/api/Relationship/Owned/ListAwaitingAcceptance`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiPagedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForPerson(request, options = {}) {
            const localVarPath = `/api/Relationship/ListForPerson`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RelationshipConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Relationship`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RelationshipConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RelationshipApi - functional programming interface
 * @export
 */
export const RelationshipApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept(value, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).accept(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept_1(value, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).accept_1(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwned(request, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).listForOwned(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwnedAwaitingAcceptance(request, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).listForOwnedAwaitingAcceptance(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForPerson(request, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).listForPerson(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {RelationshipConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = RelationshipApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * RelationshipApi - factory interface
 * @export
 */
export const RelationshipApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return RelationshipApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
         * @param {string} [contentType]
         * @param {string} [contentDisposition]
         * @param {{ [key: string]: string; }} [headers]
         * @param {number} [length]
         * @param {string} [name]
         * @param {string} [fileName]
         * @param {string} [importIdentifier]
         * @param {boolean} [createDependencies]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
            return RelationshipApiFp(configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept(value, options) {
            return RelationshipApiFp(configuration).accept(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} value
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        accept_1(value, options) {
            return RelationshipApiFp(configuration).accept_1(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return RelationshipApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwned(request, options) {
            return RelationshipApiFp(configuration).listForOwned(request, options)(fetch, basePath);
        },
        /**
         * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
         * @param {ApiPagedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForOwnedAwaitingAcceptance(request, options) {
            return RelationshipApiFp(configuration).listForOwnedAwaitingAcceptance(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForPerson(request, options) {
            return RelationshipApiFp(configuration).listForPerson(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {RelationshipConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return RelationshipApiFp(configuration).post(value, options)(fetch, basePath);
        },
    };
};
/**
 * RelationshipApi - object-oriented interface
 * @export
 * @class RelationshipApi
 * @extends {BaseAPI}
 */
export class RelationshipApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    _delete(entityId, options) {
        return RelationshipApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     * If passing in your own import identifier, make sure it is a proper GUID to avoid conflicts with other imports
     * @param {string} [contentType]
     * @param {string} [contentDisposition]
     * @param {{ [key: string]: string; }} [headers]
     * @param {number} [length]
     * @param {string} [name]
     * @param {string} [fileName]
     * @param {string} [importIdentifier]
     * @param {boolean} [createDependencies]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    _import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options) {
        return RelationshipApiFp(this.configuration)._import(contentType, contentDisposition, headers, length, name, fileName, importIdentifier, createDependencies, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    accept(value, options) {
        return RelationshipApiFp(this.configuration).accept(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} value
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    accept_1(value, options) {
        return RelationshipApiFp(this.configuration).accept_1(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    get(request, options) {
        return RelationshipApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
     * @param {ApiPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    listForOwned(request, options) {
        return RelationshipApiFp(this.configuration).listForOwned(request, options)(this.fetch, this.basePath);
    }
    /**
     * The sort applies to the order of the 'owned' people returned, not the relationships. These are sorted internally.
     * @param {ApiPagedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    listForOwnedAwaitingAcceptance(request, options) {
        return RelationshipApiFp(this.configuration).listForOwnedAwaitingAcceptance(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    listForPerson(request, options) {
        return RelationshipApiFp(this.configuration).listForPerson(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {RelationshipConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipApi
     */
    post(value, options) {
        return RelationshipApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
}
/**
 * RelationshipTypeApi - fetch parameter creator
 * @export
 */
export const RelationshipTypeApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/RelationshipType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(request, options = {}) {
            const localVarPath = `/api/RelationshipType/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RelationshipTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/RelationshipType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RelationshipTypeConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/RelationshipType/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RelationshipTypeApi - functional programming interface
 * @export
 */
export const RelationshipTypeApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = RelationshipTypeApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(request, options) {
            const localVarFetchArgs = RelationshipTypeApiFetchParamCreator(configuration).list(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {RelationshipTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = RelationshipTypeApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = RelationshipTypeApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * RelationshipTypeApi - factory interface
 * @export
 */
export const RelationshipTypeApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return RelationshipTypeApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(request, options) {
            return RelationshipTypeApiFp(configuration).list(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {RelationshipTypeConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return RelationshipTypeApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return RelationshipTypeApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * RelationshipTypeApi - object-oriented interface
 * @export
 * @class RelationshipTypeApi
 * @extends {BaseAPI}
 */
export class RelationshipTypeApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipTypeApi
     */
    _delete(entityId, options) {
        return RelationshipTypeApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipTypeApi
     */
    list(request, options) {
        return RelationshipTypeApiFp(this.configuration).list(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {RelationshipTypeConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipTypeApi
     */
    post(value, options) {
        return RelationshipTypeApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RelationshipTypeApi
     */
    restore(entityId, options) {
        return RelationshipTypeApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * RoleApi - fetch parameter creator
 * @export
 */
export const RoleApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Role`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Role/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This helper will give all roles within the current organization that contains the given group type
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllForOrganizationContaining(request, options = {}) {
            const localVarPath = `/api/Role/ListAllForOrganizationContaining`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Merge roles. Can only be called by a tenant administrator or owner
         * @param {ApiMergeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(request, options = {}) {
            const localVarPath = `/api/Role/Merge`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options = {}) {
            const localVarPath = `/api/Role/ListForGroupType`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityWithDeletedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {RoleConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Role`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("RoleConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Role/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RoleApi - functional programming interface
 * @export
 */
export const RoleApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * This helper will give all roles within the current organization that contains the given group type
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllForOrganizationContaining(request, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).listAllForOrganizationContaining(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * Merge roles. Can only be called by a tenant administrator or owner
         * @param {ApiMergeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(request, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).merge(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).listForGroupType(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {RoleConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = RoleApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * RoleApi - factory interface
 * @export
 */
export const RoleApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return RoleApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return RoleApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         * This helper will give all roles within the current organization that contains the given group type
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllForOrganizationContaining(request, options) {
            return RoleApiFp(configuration).listAllForOrganizationContaining(request, options)(fetch, basePath);
        },
        /**
         * Merge roles. Can only be called by a tenant administrator or owner
         * @param {ApiMergeRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        merge(request, options) {
            return RoleApiFp(configuration).merge(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityWithDeletedRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listForGroupType(request, options) {
            return RoleApiFp(configuration).listForGroupType(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {RoleConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return RoleApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return RoleApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * RoleApi - object-oriented interface
 * @export
 * @class RoleApi
 * @extends {BaseAPI}
 */
export class RoleApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    _delete(entityId, options) {
        return RoleApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    get(request, options) {
        return RoleApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     * This helper will give all roles within the current organization that contains the given group type
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    listAllForOrganizationContaining(request, options) {
        return RoleApiFp(this.configuration).listAllForOrganizationContaining(request, options)(this.fetch, this.basePath);
    }
    /**
     * Merge roles. Can only be called by a tenant administrator or owner
     * @param {ApiMergeRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    merge(request, options) {
        return RoleApiFp(this.configuration).merge(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityWithDeletedRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    listForGroupType(request, options) {
        return RoleApiFp(this.configuration).listForGroupType(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {RoleConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    post(value, options) {
        return RoleApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RoleApi
     */
    restore(entityId, options) {
        return RoleApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * SecurityApi - fetch parameter creator
 * @export
 */
export const SecurityApiFetchParamCreator = function (configuration) {
    return {
        /**
         * Send the body as the form post body and the signature as a header with key: Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyJsonWebSignature(options = {}) {
            const localVarPath = `/api/Security/VerifyJsonWebSignature`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SecurityApi - functional programming interface
 * @export
 */
export const SecurityApiFp = function (configuration) {
    return {
        /**
         * Send the body as the form post body and the signature as a header with key: Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyJsonWebSignature(options) {
            const localVarFetchArgs = SecurityApiFetchParamCreator(configuration).verifyJsonWebSignature(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * SecurityApi - factory interface
 * @export
 */
export const SecurityApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * Send the body as the form post body and the signature as a header with key: Signature
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyJsonWebSignature(options) {
            return SecurityApiFp(configuration).verifyJsonWebSignature(options)(fetch, basePath);
        },
    };
};
/**
 * SecurityApi - object-oriented interface
 * @export
 * @class SecurityApi
 * @extends {BaseAPI}
 */
export class SecurityApi extends BaseAPI {
    /**
     * Send the body as the form post body and the signature as a header with key: Signature
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SecurityApi
     */
    verifyJsonWebSignature(options) {
        return SecurityApiFp(this.configuration).verifyJsonWebSignature(options)(this.fetch, this.basePath);
    }
}
/**
 * SubscriptionApi - fetch parameter creator
 * @export
 */
export const SubscriptionApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Subscription`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Subscription/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options = {}) {
            const localVarPath = `/api/Subscription/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {SubscriptionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Subscription`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("SubscriptionConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Subscription/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SubscriptionApi - functional programming interface
 * @export
 */
export const SubscriptionApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).list(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {SubscriptionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = SubscriptionApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * SubscriptionApi - factory interface
 * @export
 */
export const SubscriptionApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return SubscriptionApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return SubscriptionApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            return SubscriptionApiFp(configuration).list(options)(fetch, basePath);
        },
        /**
         *
         * @param {SubscriptionConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return SubscriptionApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return SubscriptionApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * SubscriptionApi - object-oriented interface
 * @export
 * @class SubscriptionApi
 * @extends {BaseAPI}
 */
export class SubscriptionApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    _delete(entityId, options) {
        return SubscriptionApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    get(request, options) {
        return SubscriptionApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    list(options) {
        return SubscriptionApiFp(this.configuration).list(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {SubscriptionConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    post(value, options) {
        return SubscriptionApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SubscriptionApi
     */
    restore(entityId, options) {
        return SubscriptionApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * TemplateApi - fetch parameter creator
 * @export
 */
export const TemplateApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options = {}) {
            const localVarPath = `/api/Template`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options = {}) {
            const localVarPath = `/api/Template/Get`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options = {}) {
            const localVarPath = `/api/Template/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Template`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TemplateConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiProvisionRequest} [provisionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provision(provisionRequest, options = {}) {
            const localVarPath = `/api/Template/Provision`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiProvisionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(provisionRequest || {}) : (provisionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * In this call, the name is used for the group name as the template itself is not saved and the identifier from the integration properties is used for every item created
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionForImport(value, options = {}) {
            const localVarPath = `/api/Template/Provision/ForImport`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TemplateConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options = {}) {
            const localVarPath = `/api/Template/Restore`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function (configuration) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration)._delete(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).get(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).list(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiProvisionRequest} [provisionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provision(provisionRequest, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).provision(provisionRequest, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         * In this call, the name is used for the group name as the template itself is not saved and the identifier from the integration properties is used for every item created
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionForImport(value, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).provisionForImport(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            const localVarFetchArgs = TemplateApiFetchParamCreator(configuration).restore(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        _delete(entityId, options) {
            return TemplateApiFp(configuration)._delete(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(request, options) {
            return TemplateApiFp(configuration).get(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        list(options) {
            return TemplateApiFp(configuration).list(options)(fetch, basePath);
        },
        /**
         *
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return TemplateApiFp(configuration).post(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiProvisionRequest} [provisionRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provision(provisionRequest, options) {
            return TemplateApiFp(configuration).provision(provisionRequest, options)(fetch, basePath);
        },
        /**
         * In this call, the name is used for the group name as the template itself is not saved and the identifier from the integration properties is used for every item created
         * @param {TemplateConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        provisionForImport(value, options) {
            return TemplateApiFp(configuration).provisionForImport(value, options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        restore(entityId, options) {
            return TemplateApiFp(configuration).restore(entityId, options)(fetch, basePath);
        },
    };
};
/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI {
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    _delete(entityId, options) {
        return TemplateApiFp(this.configuration)._delete(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    get(request, options) {
        return TemplateApiFp(this.configuration).get(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    list(options) {
        return TemplateApiFp(this.configuration).list(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {TemplateConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    post(value, options) {
        return TemplateApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiProvisionRequest} [provisionRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    provision(provisionRequest, options) {
        return TemplateApiFp(this.configuration).provision(provisionRequest, options)(this.fetch, this.basePath);
    }
    /**
     * In this call, the name is used for the group name as the template itself is not saved and the identifier from the integration properties is used for every item created
     * @param {TemplateConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    provisionForImport(value, options) {
        return TemplateApiFp(this.configuration).provisionForImport(value, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    restore(entityId, options) {
        return TemplateApiFp(this.configuration).restore(entityId, options)(this.fetch, this.basePath);
    }
}
/**
 * TenantApi - fetch parameter creator
 * @export
 */
export const TenantApiFetchParamCreator = function (configuration) {
    return {
        /**
         * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
         * @param {string} [confirm]
         * @param {boolean} [tenants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erase(confirm, tenants, options = {}) {
            const localVarPath = `/api/Tenant`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (confirm !== undefined) {
                localVarQueryParameter['confirm'] = confirm;
            }
            if (tenants !== undefined) {
                localVarQueryParameter['tenants'] = tenants;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options = {}) {
            const localVarPath = `/api/Tenant`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(request, options = {}) {
            const localVarPath = `/api/Tenant/GetSubscriptions`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options = {}) {
            const localVarPath = `/api/Tenant/GetUsage`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options = {}) {
            const localVarPath = `/api/Tenant/Ping`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {TenantConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options = {}) {
            const localVarPath = `/api/Tenant`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("TenantConstruct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(value || {}) : (value || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TenantApi - functional programming interface
 * @export
 */
export const TenantApiFp = function (configuration) {
    return {
        /**
         * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
         * @param {string} [confirm]
         * @param {boolean} [tenants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erase(confirm, tenants, options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).erase(confirm, tenants, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).get(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(request, options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).getSubscriptions(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).getUsage(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).ping(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {TenantConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            const localVarFetchArgs = TenantApiFetchParamCreator(configuration).post(value, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * TenantApi - factory interface
 * @export
 */
export const TenantApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
         * @param {string} [confirm]
         * @param {boolean} [tenants]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        erase(confirm, tenants, options) {
            return TenantApiFp(configuration).erase(confirm, tenants, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get(options) {
            return TenantApiFp(configuration).get(options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSubscriptions(request, options) {
            return TenantApiFp(configuration).getSubscriptions(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsage(request, options) {
            return TenantApiFp(configuration).getUsage(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        ping(options) {
            return TenantApiFp(configuration).ping(options)(fetch, basePath);
        },
        /**
         *
         * @param {TenantConstruct} [value]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        post(value, options) {
            return TenantApiFp(configuration).post(value, options)(fetch, basePath);
        },
    };
};
/**
 * TenantApi - object-oriented interface
 * @export
 * @class TenantApi
 * @extends {BaseAPI}
 */
export class TenantApi extends BaseAPI {
    /**
     * To confirm this, pass the value YES in the confirm property. THIS CANNOT BE REVERSED. This is only available to tenant owners.
     * @param {string} [confirm]
     * @param {boolean} [tenants]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    erase(confirm, tenants, options) {
        return TenantApiFp(this.configuration).erase(confirm, tenants, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    get(options) {
        return TenantApiFp(this.configuration).get(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    getSubscriptions(request, options) {
        return TenantApiFp(this.configuration).getSubscriptions(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    getUsage(request, options) {
        return TenantApiFp(this.configuration).getUsage(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    ping(options) {
        return TenantApiFp(this.configuration).ping(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {TenantConstruct} [value]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenantApi
     */
    post(value, options) {
        return TenantApiFp(this.configuration).post(value, options)(this.fetch, this.basePath);
    }
}
/**
 * TestResponseApi - fetch parameter creator
 * @export
 */
export const TestResponseApiFetchParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failure(options = {}) {
            const localVarPath = `/api/TestResponse/Failure`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {boolean} [verify]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        success(verify, options = {}) {
            const localVarPath = `/api/TestResponse/Success`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (verify !== undefined) {
                localVarQueryParameter['verify'] = verify;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TestResponseApi - functional programming interface
 * @export
 */
export const TestResponseApiFp = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failure(options) {
            const localVarFetchArgs = TestResponseApiFetchParamCreator(configuration).failure(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {boolean} [verify]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        success(verify, options) {
            const localVarFetchArgs = TestResponseApiFetchParamCreator(configuration).success(verify, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * TestResponseApi - factory interface
 * @export
 */
export const TestResponseApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        failure(options) {
            return TestResponseApiFp(configuration).failure(options)(fetch, basePath);
        },
        /**
         *
         * @param {boolean} [verify]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        success(verify, options) {
            return TestResponseApiFp(configuration).success(verify, options)(fetch, basePath);
        },
    };
};
/**
 * TestResponseApi - object-oriented interface
 * @export
 * @class TestResponseApi
 * @extends {BaseAPI}
 */
export class TestResponseApi extends BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResponseApi
     */
    failure(options) {
        return TestResponseApiFp(this.configuration).failure(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {boolean} [verify]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TestResponseApi
     */
    success(verify, options) {
        return TestResponseApiFp(this.configuration).success(verify, options)(this.fetch, this.basePath);
    }
}
/**
 * UserApi - fetch parameter creator
 * @export
 */
export const UserApiFetchParamCreator = function (configuration) {
    return {
        /**
         * This does not delete the entity, but removes it from the favourites
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavourite(entityId, options = {}) {
            const localVarPath = `/api/User/Favourite`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (entityId !== undefined) {
                localVarQueryParameter['entityId'] = entityId;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForPerson(request, options = {}) {
            const localVarPath = `/api/User/GetForPerson`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = ("ApiEntityRawRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(request || {}) : (request || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options = {}) {
            const localVarPath = `/api/User/GetSelf`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary ChiRhos Owners only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllSummary(options = {}) {
            const localVarPath = `/api/User/ListAllSummary`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFavourites(options = {}) {
            const localVarPath = `/api/User/Favourite/List`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [userEntityId]
         * @param {boolean} [isTenantAdmin]
         * @param {boolean} [isTenantOwner]
         * @param {boolean} [isChiRhosOwner]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options = {}) {
            const localVarPath = `/api/User/Set`;
            const localVarUrlObj = new URL(localVarPath, configuration.basePath);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = { Authorization: 'Bearer ' + configuration.accessToken };
            const localVarQueryParameter = {};
            if (userEntityId !== undefined) {
                localVarQueryParameter['userEntityId'] = userEntityId;
            }
            if (isTenantAdmin !== undefined) {
                localVarQueryParameter['isTenantAdmin'] = isTenantAdmin;
            }
            if (isTenantOwner !== undefined) {
                localVarQueryParameter['isTenantOwner'] = isTenantOwner;
            }
            if (isChiRhosOwner !== undefined) {
                localVarQueryParameter['isChiRhosOwner'] = isChiRhosOwner;
            }
            localVarUrlObj.search = querystring.encode(Object.assign({}, localVarUrlObj.searchParams, localVarQueryParameter, options.query)).toString();
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function (configuration) {
    return {
        /**
         * This does not delete the entity, but removes it from the favourites
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavourite(entityId, options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).deleteFavourite(entityId, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForPerson(request, options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).getForPerson(request, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).getSelf(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @summary ChiRhos Owners only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllSummary(options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).listAllSummary(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFavourites(options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).listFavourites(options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        /**
         *
         * @param {string} [userEntityId]
         * @param {boolean} [isTenantAdmin]
         * @param {boolean} [isTenantOwner]
         * @param {boolean} [isChiRhosOwner]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options) {
            const localVarFetchArgs = UserApiFetchParamCreator(configuration).set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options);
            return (fetch = portableFetch, basePath = BASE_PATH) => {
                return fetch(localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration, fetch, basePath) {
    return {
        /**
         * This does not delete the entity, but removes it from the favourites
         * @param {string} [entityId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFavourite(entityId, options) {
            return UserApiFp(configuration).deleteFavourite(entityId, options)(fetch, basePath);
        },
        /**
         *
         * @param {ApiEntityRawRequest} [request]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForPerson(request, options) {
            return UserApiFp(configuration).getForPerson(request, options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSelf(options) {
            return UserApiFp(configuration).getSelf(options)(fetch, basePath);
        },
        /**
         *
         * @summary ChiRhos Owners only
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllSummary(options) {
            return UserApiFp(configuration).listAllSummary(options)(fetch, basePath);
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFavourites(options) {
            return UserApiFp(configuration).listFavourites(options)(fetch, basePath);
        },
        /**
         *
         * @param {string} [userEntityId]
         * @param {boolean} [isTenantAdmin]
         * @param {boolean} [isTenantOwner]
         * @param {boolean} [isChiRhosOwner]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options) {
            return UserApiFp(configuration).set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options)(fetch, basePath);
        },
    };
};
/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * This does not delete the entity, but removes it from the favourites
     * @param {string} [entityId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    deleteFavourite(entityId, options) {
        return UserApiFp(this.configuration).deleteFavourite(entityId, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {ApiEntityRawRequest} [request]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    getForPerson(request, options) {
        return UserApiFp(this.configuration).getForPerson(request, options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    getSelf(options) {
        return UserApiFp(this.configuration).getSelf(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @summary ChiRhos Owners only
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    listAllSummary(options) {
        return UserApiFp(this.configuration).listAllSummary(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    listFavourites(options) {
        return UserApiFp(this.configuration).listFavourites(options)(this.fetch, this.basePath);
    }
    /**
     *
     * @param {string} [userEntityId]
     * @param {boolean} [isTenantAdmin]
     * @param {boolean} [isTenantOwner]
     * @param {boolean} [isChiRhosOwner]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options) {
        return UserApiFp(this.configuration).set(userEntityId, isTenantAdmin, isTenantOwner, isChiRhosOwner, options)(this.fetch, this.basePath);
    }
}
